import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import { IRate } from 'types/contractLanes'
import { FormModal, IModalBaseProps } from 'transfix-ui'

interface ILaneRemoveModalProps extends Pick<IModalBaseProps, 'onClose'> {
  onRemoveLanes: (contractIds: number[]) => void
  data?: Partial<IRate>
  deleting: boolean
  error?: string
}

export const LaneRemoveModal = memo<ILaneRemoveModalProps>(
  ({ data: contractRate, deleting, error, onClose, onRemoveLanes }) => {
    const onModalResult = (action?: string) => {
      if (action === 'confirm') {
        onRemoveLanes([contractRate?.contractId || 0])
      } else {
        onClose()
      }
    }

    return (
      <FormModal
        title='Are you sure?'
        size={6}
        onClose={onModalResult}
        open={Boolean(contractRate?.contractId)}
        error={error}
        actions={[
          {
            type: 'dismiss',
            label: 'Cancel',
            disabled: deleting,
            dataTest: 'cancel-remove-rates-button',
          },
          {
            type: 'confirm',
            label: 'Delete rate',
            disabled: deleting,
            dataTest: 'remove-rates-button',
          },
        ]}>
        <div data-test='remove-message'>
          <Typography>This carrier will no longer receive shipments at this lane rate.</Typography>
        </div>
      </FormModal>
    )
  }
)
